"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitterApiV2Settings = void 0;
exports.TwitterApiV2Settings = {
    debug: false,
    deprecationWarnings: true,
    logger: { log: console.log.bind(console) },
};
